export default __webpack_public_path__ + "static/media/websafe-app-logo-900px.944bdfa3.png";